import { create } from "zustand";

export const AmbientalStore = create((set) => ({
  nascentesValue: null,
  aguaCorrenteValue: null,
  mataValue: null,

  ambientalMapImage: null,
  nascentesImage: null,
  aguaCorrenteImage: null,
  mataImage: null,

  setNascentesValue: (val) => set({ nascentesValue: val }),

  setAguaCorrenteValue: (val) => set({ aguaCorrenteValue: val }),

  setMataValue: (val) => set({ mataValue: val }),


  setAmbientalMapImage: (img) => set({ambientalMapImage: img }),

  setNascentesImage: (img) => set({ nascentesImage: img }),

  setAguaCorrenteImage: (img) => set({ aguaCorrenteImage: img }),

  setMataImage: (img) => set({ mataImage: img }),

  agrotoxicoValue: null,
  problemaSaudeAgrotoxicoValue: null,

  agrotoxicoImage: null,
  problemaSaudeAgrotoxicoImage: null,

  setAgrotoxicoValue: (val) => set({ agrotoxicoValue: val }),

  setProblemaSaudeAgrotoxicoValue: (val) =>
    set({ problemaSaudeAgrotoxicoValue: val }),

  setAgrotoxicoImage: (img) => set({ agrotoxicoImage: img }),

  setProblemaSaudeAgrotoxicoImage: (img) =>
    set({ problemaSaudeAgrotoxicoImage: img }),

  setTipoMataImage: (img) => set({ tipoMataImage: img }),

  reset: () =>
    set({
      nascentesValue: null,
      aguaCorrenteValue: null,
      mataValue: null,
      agrotoxicoValue: null,
      problemaSaudeAgrotoxicoValue: null,
    }),
}));
